import { css } from 'styled-components';

export const displayLarge = css`
  font-family: var(--sys-typescale-display-large-font);
  font-size: var(--sys-typescale-display-large-size);
  font-weight: var(--sys-typescale-display-large-weight);
  line-height: var(--sys-typescale-display-large-line-height);
  letter-spacing: var(--sys-typescale-display-large-tracking);
`;

export const displayLargeEmphasized = css`
  font-family: var(--sys-typescale-display-large-font);
  font-size: var(--sys-typescale-display-large-size);
  font-weight: var(--sys-typescale-display-large-weight-emphasized);
  line-height: var(--sys-typescale-display-large-line-height);
  letter-spacing: var(--sys-typescale-display-large-tracking);
`;

export const displayMedium = css`
  font-family: var(--sys-typescale-display-medium-font);
  font-size: var(--sys-typescale-display-medium-size);
  font-weight: var(--sys-typescale-display-medium-weight);
  line-height: var(--sys-typescale-display-medium-line-height);
  letter-spacing: var(--sys-typescale-display-medium-tracking);
`;

export const displayMediumEmphasized = css`
  font-family: var(--sys-typescale-display-medium-font);
  font-size: var(--sys-typescale-display-medium-size);
  font-weight: var(--sys-typescale-display-medium-weight-emphasized);
  line-height: var(--sys-typescale-display-medium-line-height);
  letter-spacing: var(--sys-typescale-display-medium-tracking);
`;

export const displaySmall = css`
  font-family: var(--sys-typescale-display-small-font);
  font-size: var(--sys-typescale-display-small-size);
  font-weight: var(--sys-typescale-display-small-weight);
  line-height: var(--sys-typescale-display-small-line-height);
  letter-spacing: var(--sys-typescale-display-small-tracking);
`;

export const displaySmallEmphasized = css`
  font-family: var(--sys-typescale-display-small-font);
  font-size: var(--sys-typescale-display-small-size);
  font-weight: var(--sys-typescale-display-small-weight-emphasized);
  line-height: var(--sys-typescale-display-small-line-height);
  letter-spacing: var(--sys-typescale-display-small-tracking);
`;

export const headlineLarge = css`
  font-family: var(--sys-typescale-headline-large-font);
  font-size: var(--sys-typescale-headline-large-size);
  font-weight: var(--sys-typescale-headline-large-weight);
  line-height: var(--sys-typescale-headline-large-line-height);
  letter-spacing: var(--sys-typescale-headline-large-tracking);
`;

export const headlineLargeEmphasized = css`
  font-family: var(--sys-typescale-headline-large-font);
  font-size: var(--sys-typescale-headline-large-size);
  font-weight: var(--sys-typescale-headline-large-weight-emphasized);
  line-height: var(--sys-typescale-headline-large-line-height);
  letter-spacing: var(--sys-typescale-headline-large-tracking);
`;

export const headlineMedium = css`
  font-family: var(--sys-typescale-headline-medium-font);
  font-size: var(--sys-typescale-headline-medium-size);
  font-weight: var(--sys-typescale-headline-medium-weight);
  line-height: var(--sys-typescale-headline-medium-line-height);
  letter-spacing: var(--sys-typescale-headline-medium-tracking);
`;

export const headlineMediumEmphasized = css`
  font-family: var(--sys-typescale-headline-medium-font);
  font-size: var(--sys-typescale-headline-medium-size);
  font-weight: var(--sys-typescale-headline-medium-weight-emphasized);
  line-height: var(--sys-typescale-headline-medium-line-height);
  letter-spacing: var(--sys-typescale-headline-medium-tracking);
`;

export const headlineSmall = css`
  font-family: var(--sys-typescale-headline-small-font);
  font-size: var(--sys-typescale-headline-small-size);
  font-weight: var(--sys-typescale-headline-small-weight);
  line-height: var(--sys-typescale-headline-small-line-height);
  letter-spacing: var(--sys-typescale-headline-small-tracking);
`;

export const headlineSmallEmphasized = css`
  font-family: var(--sys-typescale-headline-small-font);
  font-size: var(--sys-typescale-headline-small-size);
  font-weight: var(--sys-typescale-headline-small-weight-emphasized);
  line-height: var(--sys-typescale-headline-small-line-height);
  letter-spacing: var(--sys-typescale-headline-small-tracking);
`;

export const titleLarge = css`
  font-family: var(--sys-typescale-title-large-font);
  font-size: var(--sys-typescale-title-large-size);
  font-weight: var(--sys-typescale-title-large-weight);
  line-height: var(--sys-typescale-title-large-line-height);
  letter-spacing: var(--sys-typescale-title-large-tracking);
`;

export const titleLargeEmphasized = css`
  font-family: var(--sys-typescale-title-large-font);
  font-size: var(--sys-typescale-title-large-size);
  font-weight: var(--sys-typescale-title-large-weight-emphasized);
  line-height: var(--sys-typescale-title-large-line-height);
  letter-spacing: var(--sys-typescale-title-large-tracking);
`;

export const titleMedium = css`
  font-family: var(--sys-typescale-title-medium-font);
  font-size: var(--sys-typescale-title-medium-size);
  font-weight: var(--sys-typescale-title-medium-weight);
  line-height: var(--sys-typescale-title-medium-line-height);
  letter-spacing: var(--sys-typescale-title-medium-tracking);
`;

export const titleMediumEmphasized = css`
  font-family: var(--sys-typescale-title-medium-font);
  font-size: var(--sys-typescale-title-medium-size);
  font-weight: var(--sys-typescale-title-medium-weight-emphasized);
  line-height: var(--sys-typescale-title-medium-line-height);
  letter-spacing: var(--sys-typescale-title-medium-tracking);
`;

export const titleSmall = css`
  font-family: var(--sys-typescale-title-small-font);
  font-size: var(--sys-typescale-title-small-size);
  font-weight: var(--sys-typescale-title-small-weight);
  line-height: var(--sys-typescale-title-small-line-height);
  letter-spacing: var(--sys-typescale-title-small-tracking);
`;

export const titleSmallEmphasized = css`
  font-family: var(--sys-typescale-title-small-font);
  font-size: var(--sys-typescale-title-small-size);
  font-weight: var(--sys-typescale-title-small-weight-emphasized);
  line-height: var(--sys-typescale-title-small-line-height);
  letter-spacing: var(--sys-typescale-title-small-tracking);
`;

export const labelLarge = css`
  font-family: var(--sys-typescale-label-large-font);
  font-size: var(--sys-typescale-label-large-size);
  font-weight: var(--sys-typescale-label-large-weight);
  line-height: var(--sys-typescale-label-large-line-height);
  letter-spacing: var(--sys-typescale-label-large-tracking);
`;

export const labelLargeEmphasized = css`
  font-family: var(--sys-typescale-label-large-font);
  font-size: var(--sys-typescale-label-large-size);
  font-weight: var(--sys-typescale-label-large-weight-emphasized);
  line-height: var(--sys-typescale-label-large-line-height);
  letter-spacing: var(--sys-typescale-label-large-tracking);
`;

export const labelMedium = css`
  font-family: var(--sys-typescale-label-medium-font);
  font-size: var(--sys-typescale-label-medium-size);
  font-weight: var(--sys-typescale-label-medium-weight);
  line-height: var(--sys-typescale-label-medium-line-height);
  letter-spacing: var(--sys-typescale-label-medium-tracking);
`;

export const labelMediumEmphasized = css`
  font-family: var(--sys-typescale-label-medium-font);
  font-size: var(--sys-typescale-label-medium-size);
  font-weight: var(--sys-typescale-label-medium-weight-emphasized);
  line-height: var(--sys-typescale-label-medium-line-height);
  letter-spacing: var(--sys-typescale-label-medium-tracking);
`;

export const labelSmall = css`
  font-family: var(--sys-typescale-label-small-font);
  font-size: var(--sys-typescale-label-small-size);
  font-weight: var(--sys-typescale-label-small-weight);
  line-height: var(--sys-typescale-label-small-line-height);
  letter-spacing: var(--sys-typescale-label-small-tracking);
`;

export const labelSmallEmphasized = css`
  font-family: var(--sys-typescale-label-small-font);
  font-size: var(--sys-typescale-label-small-size);
  font-weight: var(--sys-typescale-label-small-weight-emphasized);
  line-height: var(--sys-typescale-label-small-line-height);
  letter-spacing: var(--sys-typescale-label-small-tracking);
`;

export const bodyLarge = css`
  font-family: var(--sys-typescale-body-large-font);
  font-size: var(--sys-typescale-body-large-size);
  font-weight: var(--sys-typescale-body-large-weight);
  line-height: var(--sys-typescale-body-large-line-height);
  letter-spacing: var(--sys-typescale-body-large-tracking);
`;

export const bodyLargeEmphasized = css`
  font-family: var(--sys-typescale-body-large-font);
  font-size: var(--sys-typescale-body-large-size);
  font-weight: var(--sys-typescale-body-large-weight-emphasized);
  line-height: var(--sys-typescale-body-large-line-height);
  letter-spacing: var(--sys-typescale-body-large-tracking);
`;

export const bodyMedium = css`
  font-family: var(--sys-typescale-body-medium-font);
  font-size: var(--sys-typescale-body-medium-size);
  font-weight: var(--sys-typescale-body-medium-weight);
  line-height: var(--sys-typescale-body-medium-line-height);
  letter-spacing: var(--sys-typescale-body-medium-tracking);
`;

export const bodyMediumEmphasized = css`
  font-family: var(--sys-typescale-body-medium-font);
  font-size: var(--sys-typescale-body-medium-size);
  font-weight: var(--sys-typescale-body-medium-weight-emphasized);
  line-height: var(--sys-typescale-body-medium-line-height);
  letter-spacing: var(--sys-typescale-body-medium-tracking);
`;

export const bodySmall = css`
  font-family: var(--sys-typescale-body-small-font);
  font-size: var(--sys-typescale-body-small-size);
  font-weight: var(--sys-typescale-body-small-weight);
  line-height: var(--sys-typescale-body-small-line-height);
  letter-spacing: var(--sys-typescale-body-small-tracking);
`;

export const bodySmallEmphasized = css`
  font-family: var(--sys-typescale-body-small-font);
  font-size: var(--sys-typescale-body-small-size);
  font-weight: var(--sys-typescale-body-small-weight-emphasized);
  line-height: var(--sys-typescale-body-small-line-height);
  letter-spacing: var(--sys-typescale-body-small-tracking);
`;
